import { queryOptions } from "@tanstack/react-query";
import { FundingApplicationSchemas } from "api-types";
import { axiosClient } from "auth-sdk";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import type { FundingApplicationReviewDetailsElapsedTime } from "../../funding-application";

dayjs.extend(relativeTime);

const FUNDING_APPLICATION_REVIEW_DETAILS_API = "/api/:customerSlug/funding/api/review/details";
const FUNDING_APPLICATION_REVIEW_DETAILS_KEY = "funding-application-review-details";

export const getInReviewDetailsQueryKey = (customerDomain: string) => [
  FUNDING_APPLICATION_REVIEW_DETAILS_KEY,
  customerDomain,
];

//TODO: this should support a productRequestId
export const getInReviewDetailsQuery = (customerDomain: string, ready: boolean) => {
  const url = FUNDING_APPLICATION_REVIEW_DETAILS_API.replace(":customerSlug", customerDomain);
  const queryFn = () => axiosClient.get<FundingApplicationSchemas.FundingApplicationReviewDetails>(url);
  return queryOptions({
    queryKey: getInReviewDetailsQueryKey(customerDomain),
    queryFn,
    enabled: ready,
    select: ({ data }): FundingApplicationReviewDetailsElapsedTime => {
      return {
        ...data,
        elapsedTime: data.submittedDatetime ? dayjs(data.submittedDatetime).fromNow(true) : null,
        elapsedSeconds: data.submittedDatetime
          ? Math.max(dayjs().diff(dayjs(data.submittedDatetime), "second"), 1)
          : null,
      };
    },
    refetchOnMount: true,
    refetchInterval: 10000,
  });
};
